enum OrganizationActionTypes {
	CREATE_ORGANIZATION = "CREATE_ORGANIZATION",
	GET_ORGANIZATION_INFO = "GET_ORGANIZATION_INFO",
	GET_ORGANIZATION_FOR_ADMIN = "GET_ORGANIZATION_FOR_ADMIN",
	UPDATE_ORGANIZATION_INFO = "UPDATE_ORGANIZATION_INFO",
}

export default OrganizationActionTypes;
